import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const WHATSAPP_NUMBER = "919491085798";

export async function submitLead(payload) {
    const { data } = await axios.post(`${API}/leads`, payload);
    return data;
}

export async function submitCatalogRequest(payload) {
    const { data } = await axios.post(`${API}/catalog-requests`, payload);
    return data;
}

function nowIST() {
    return new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        dateStyle: "medium",
        timeStyle: "short",
    });
}

const SOURCE_LABELS = {
    homepage_inquiry: "Home page · Inquiry Form",
    contact_page: "Contact page · Business Enquiry",
    request_quote: "Request a Quote",
    catalog: "Download Product Catalog",
};

function labelForSource(src = "") {
    if (SOURCE_LABELS[src]) return SOURCE_LABELS[src];
    if (src.startsWith("product:")) {
        const slug = src.replace("product:", "");
        return `Product page · ${slug}`;
    }
    return src || "Website Enquiry";
}

/**
 * Build the WhatsApp deep-link for an enquiry form submission.
 * Always uses wa.me (works on mobile + desktop, opens app/web).
 */
export function buildEnquiryWhatsApp(payload, phone = WHATSAPP_NUMBER) {
    const lines = [
        "*New Export Enquiry — RP Traders*",
        "",
        `Full Name: ${payload.name || "—"}`,
        `Company: ${payload.company || "—"}`,
        `Country: ${payload.country || "—"}`,
        `Email: ${payload.email || "—"}`,
        `WhatsApp Number: ${payload.whatsapp || "—"}`,
        `Product Interested: ${payload.product || "—"}`,
        `Quantity Required: ${payload.quantity || "—"}`,
        payload.message ? `Message: ${payload.message}` : "Message: —",
        `Source Form: ${labelForSource(payload.source)}`,
        `Submitted: ${nowIST()} IST`,
    ];
    return `https://wa.me/${phone}?text=${encodeURIComponent(lines.join("\n"))}`;
}

/**
 * Build the WhatsApp deep-link for a catalog download request.
 */
export function buildCatalogWhatsApp(payload, phone = WHATSAPP_NUMBER) {
    const lines = [
        "*Catalog Download Request — RP Traders*",
        "",
        `Full Name: ${payload.name || "—"}`,
        `Company: ${payload.company || "—"}`,
        `Country: ${payload.country || "—"}`,
        `Email: ${payload.email || "—"}`,
        `WhatsApp Number: ${payload.whatsapp || "—"}`,
        "Source Form: Download Product Catalog",
        `Submitted: ${nowIST()} IST`,
    ];
    return `https://wa.me/${phone}?text=${encodeURIComponent(lines.join("\n"))}`;
}

/**
 * Open a wa.me link reliably across desktop/mobile/popup-blockers.
 * Pre-opened windows from a user gesture survive async API calls.
 */
export function openWhatsApp(preOpenedWindow, url) {
    try {
        if (preOpenedWindow && !preOpenedWindow.closed) {
            preOpenedWindow.location.href = url;
            return;
        }
    } catch (_) {
        /* cross-origin assignment quirks */
    }
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (!w) {
        // Popup blocked — fall back to same-tab navigation
        window.location.href = url;
    }
}

// Back-compat (used elsewhere)
export const buildWhatsAppLink = (phone, payload) =>
    buildEnquiryWhatsApp(payload, phone);

